// Module
var code = `<div class="js-tradingCentral">
    <div class="tradingCentral-header">
        <terceraInstrumentLookup mayContainTrees="true" selectedItem="{{.instrument}}" selectedAccount="{{account}}" />
        <terceraButton visible="{{.showSwitcher}}" text="{{.screenBtnText}}" terceraButtonStyle="{{.screenBtnStyle}}" on-btnClick="@this.onScreenBtnClick()" />
        <terceraButton visible="{{.showSwitcher}}" text="{{.chartBtnText}}" terceraButtonStyle="{{.chartBtnStyle}}" on-btnClick="@this.onChartBtnClick()" />

        {{#if noData && showChart}}
            <terceraButton name="toolsButton"
                terceraButtonStyle="js-button-toolsButton"
                canCheck="true"
                SVG="true"
                checked="{{.showToolsPanel}}" />

            <terceraButton name="indicatorButton"
                        SVG="true"
                        terceraButtonStyle="js-button-indicatorButton"
                        on-btnClick="indicatorButton_btnClick" />
        {{/if}}
    </div>
    <div class="tradingCentral-main-block" {{#noData}}style="display:none"{{/}}>
        <div class="js-tradingCentral-chart">
                <terceraPictureBox name="screenIMG" useCustomSize="false" visible="{{!showChart}}" imageUrl="{{.screenImgURL}}" />
                <terceraChartToolsPanel name="toolsPanel" visible="{{.showToolsPanel && .showChart}}" />
                <terceraChartRactive name="chart" visible="{{.showChart}}" terceraChartPanelContext="{{.terceraChartPanelContext}}" />
        </div>

        <resizeSplitter isActive="{{!noData}}" isHorizontal="true" on-splitterResize="@this.layoutTable()"/>

        <div class="js-tradingCentral-tables" >
            <terceraTabContainer name="tabs" tabHeaderKeys="{{.tabHeaderKeys}}" />
            <div class="tradingCentral-container-table">
                <quickTableRactive name="quickTableRactive" visible="{{!noDataInTable}}"/>
                <div class="js-tradingCentral-noData" style="display:{{.noDataInTable?'flex':'none'}}" on-mousedown="@this.noDataMouseDown(event)" ></div>
            </div>
        </div>
    </div>
    <div class="js-tradingCentral-noData" style="display:{{.noData?'flex':'none'}}" on-mousedown="@this.noDataMouseDown(event)"></div>
</div>`;
// Exports
export default code;